
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/sentry.client.config.ts")
            }
          });